const isBlank = (value: unknown) =>
  value === null || value === undefined || (typeof value === 'string' && value.trim() === '')

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && Object.getPrototypeOf(value) === Object.prototype

/**
 * Whether a form still holds what it loaded, as a person would judge it: an empty field is empty whether it started
 * `null`, `undefined` or `''` (a field typed into and cleared again is not an edit), text compares without its
 * surrounding whitespace, and lists and objects compare by content. Anything else (a File, a Date) by identity.
 * Clearing a field that held a value is still a change.
 */
export function sameFormValue(a: unknown, b: unknown): boolean {
  if (isBlank(a) && isBlank(b)) return true
  if (typeof a === 'string' && typeof b === 'string') return a.trim() === b.trim()
  if (Array.isArray(a) || Array.isArray(b)) {
    if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false
    return a.every((item, index) => sameFormValue(item, b[index]))
  }
  if (isPlainObject(a) && isPlainObject(b)) {
    const keys = new Set([...Object.keys(a), ...Object.keys(b)])
    for (const key of keys) if (!sameFormValue(a[key], b[key])) return false
    return true
  }
  return Object.is(a, b)
}
